// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A company providing public transport services (aka Carrier, Business-Organisation).
 * @export
 * @interface Operator
 */
export interface Operator {
    /**
     * Atlas/INFO+/Plabe related operator-number (typically Integer for CH managed codes, however some TU's like in foreign countries might return String expressions like '80___'), relates to operatorName.
     * NOVA does not accept trimmed numbers!
     * @type {string}
     * @memberof Operator
     */
    id: string;
    /**
     * Fullname of responsible operator, relates to operatorNumber. This value matches with [OpenTransportData.swiss GoList field 'BEZEICHNUNG_DE'](https://opentransportdata.swiss/de/dataset/goch).<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof Operator
     */
    name?: string;
    /**
     * Abbreviation of operator, relates to operatorName. This value might differ from OpenTransportData.swiss abbreviation (there are 3 different versions, J-S supports 3-digit abbreviation).<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof Operator
     */
    shortName?: string;
    /**
     * Identification of a swiss business organisation, aka SBOID. Part of standard: Swiss ID for Public Transport.
     * @type {string}
     * @memberof Operator
     */
    swissBusinessOrganisationId?: string;
}

/**
 * Check if a given object implements the Operator interface.
 */
export function instanceOfOperator(value: object): value is Operator {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OperatorFromJSON(json: any): Operator {
    return OperatorFromJSONTyped(json, false);
}

export function OperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Operator {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'swissBusinessOrganisationId': json['swissBusinessOrganisationId'] == null ? undefined : json['swissBusinessOrganisationId'],
    };
}

  export function OperatorToJSON(json: any): Operator {
      return OperatorToJSONTyped(json, false);
  }

  export function OperatorToJSONTyped(value?: Operator | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'shortName': value['shortName'],
        'swissBusinessOrganisationId': value['swissBusinessOrganisationId'],
    };
}

